"use client";

import DreamnOddsTrendArrow from "./DreamnOddsTrendArrow";

export function dreamnDisplayValue(value) {
  return value ? value : "-";
}

export function DreamnOtherBetsStatus({ trend }) {
  return (
    <span className="inline-flex shrink-0 items-center justify-center">
      <DreamnOddsTrendArrow trend={trend} />
    </span>
  );
}
